import React from 'react';
import { MenuItemWithImage } from '../../DropdownMenu/DropdownMenuFilter.component';
import { ItemsFilter, ItemsFilterProps } from './ItemsFilter.component';
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import AssignmentLateOutlinedIcon from '@mui/icons-material/AssignmentLateOutlined';
import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';

const getVerifierMenuItems = <T,>(checkedItems: T[], isVerifier?: boolean): MenuItemWithImage<string>[] => {
  const isVerifierAssignedChecked = checkedItems.includes('5' as unknown as T);

  const subordinateItems: MenuItemWithImage<string>[] = [
    {
      value: '0',
      text: 'Praca niezweryfikowana',
      jsxElement: (
        <AssignmentIndOutlinedIcon style={{ fill: '#008000', transform: 'translateY(3px)' }} fontSize="small" />
      ),
    },
    {
      value: '1',
      text: 'Praca zweryfikowana - brak zmian w ocenie',
      jsxElement: <AssignmentOutlinedIcon fontSize="small" style={{ transform: 'translateY(3px)' }} />,
    },
    {
      value: '2',
      text: 'Praca zweryfikowana - czeka na zatwierdzenie PZE',
      jsxElement: (
        <AssignmentLateOutlinedIcon style={{ fill: '#BC0000', transform: 'translateY(3px)' }} fontSize="small" />
      ),
    },
    {
      value: '3',
      text: 'Praca zweryfikowana - zatwierdzona przez PZE',
      jsxElement: (
        <AssignmentTurnedInOutlinedIcon style={{ fill: '#347F42', transform: 'translateY(3px)' }} fontSize="small" />
      ),
    },
  ];

  if (isVerifier) {
    return subordinateItems;
  }

  const baseItems: MenuItemWithImage<string>[] = [
    { value: '5', text: 'Weryfikator przypisany' },
    { value: '4', text: 'Prace możliwe do przypisania' },
  ];

  if (!isVerifierAssignedChecked) return baseItems;

  return [...baseItems, { text: '', divider: true }, ...subordinateItems];
};

const VERIFIER_SUBORDINATE_VALUES = ['0', '1', '2', '3'];

const transformVerifierCheckedItems = <T,>(newItems: T[], prevItems: T[]): T[] => {
  const wasAssignedChecked = prevItems.includes('5' as unknown as T);
  const isAssignedChecked = newItems.includes('5' as unknown as T);
  const wasAssignableChecked = prevItems.includes('4' as unknown as T);
  const isAssignableChecked = newItems.includes('4' as unknown as T);
  const subordinates = VERIFIER_SUBORDINATE_VALUES as unknown as T[];

  if (!wasAssignedChecked && isAssignedChecked) {
    return newItems.filter((item) => item !== ('4' as unknown as T));
  } else if (!wasAssignableChecked && isAssignableChecked) {
    return newItems.filter((item) => item !== ('5' as unknown as T) && !subordinates.includes(item));
  } else if (wasAssignedChecked && !isAssignedChecked) {
    return newItems.filter((item) => !subordinates.includes(item));
  }
  return newItems;
};

interface VerifierFilterProps<T> extends ItemsFilterProps<T> {
  isVerifier?: boolean;
}

export const VerifierFilter = <T,>({ isVerifier, ...props }: VerifierFilterProps<T>): JSX.Element => {
  return (
    <ItemsFilter
      {...props}
      getMenuItemsWithImages={(checkedItems) =>
        getVerifierMenuItems(checkedItems, isVerifier) as unknown as MenuItemWithImage<T>[]
      }
      transformCheckedItems={transformVerifierCheckedItems}
      getTransformOrigin={(checkedItems) =>
        checkedItems.includes('5' as unknown as T) || isVerifier
          ? { vertical: 'top', horizontal: 50 }
          : { vertical: 'top', horizontal: 0 }
      }
    />
  );
};
